import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import React from 'react';
import {
    Controlled_AutocompleteMultiSelectReferenceTextField,
} from './Controlled_AutocompleteMultiSelectReferenceTextField';
import { useObjectiveActions } from '../../../../resource/resources/artifacts/objective/objectiveResource';

export const Controlled_ObjectiveTextField= ({ objectIds, projectVersionId, onChange, readOnly, noLabel, propertyValidationInformation }: {
    objectIds: string[] | undefined;
    projectVersionId: string | undefined | null;
    onChange?: (id: string[] | null) => void;
    readOnly: boolean;
    noLabel?: boolean;
    propertyValidationInformation?: PropertyValidationInformation;
}) => {

    const objectiveActions = useObjectiveActions()
    const objectivesQuery = objectiveActions.useGetAllResources(projectVersionId);

    return (
        <Controlled_AutocompleteMultiSelectReferenceTextField
            idValues={objectIds}
            readOnly={readOnly}
            onChange={onChange}
            // propertyValidation={propertyValidation}
            // propertyDetails={noLabel ? undefined : propertyDetails}
            propertyValidation={null}
            propertyDetails={undefined}
            query={objectivesQuery}
            getOptionLabel={(option) => option.name}
            hideLabel={noLabel}
        />
    );
};